import { useState } from "react";
import company1 from "../assets/images/company1.png";
import company2 from "../assets/images/company2.png";
import company3 from "../assets/images/company3.png";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const slides = [company1, company2, company3];

const TopCompaniesSection = () => {
  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex((prev) =>
      prev + 1 >= slides.length ? 0 : prev + 1
    );
  };

  const prev = () => {
    setIndex((prev) =>
      prev - 1 < 0 ? slides.length - 1 : prev - 1
    );
  };

  return (
    <section className="py-16 px-6 bg-gradient-to-r from-[#080713] to-[#020207]">

      <h2 className="text-center text-white text-3xl md:text-4xl font-bold mb-10">
        Our Intern's Work at Top Tech Companies
      </h2>

      {/* White Box */}
      <div className="relative max-w-5xl mx-auto bg-white rounded-2xl shadow-xl py-8 px-10 flex flex-col items-center">

        {/* Left Arrow */}
        <button
          onClick={prev}
          className="absolute left-6 top-1/2 -translate-y-1/2 text-gray-600 hover:text-black text-2xl"
        >
          <FaChevronLeft />
        </button>

        {/* Image Slide */}
        <div className="w-full flex items-center justify-center">
          <img
            src={slides[index]}
            alt="Top Companies"
            className="max-h-full max-w-full object-contain transition"
          />
        </div>

        {/* Right Arrow */}
        <button
          onClick={next}
          className="absolute right-6 top-1/2 -translate-y-1/2 text-gray-600 hover:text-black text-2xl"
        >
          <FaChevronRight />
        </button>

      </div>
    </section>
  );
};

export default TopCompaniesSection;
